import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useKnowledgeStore } from '@getmayday/vue-modules';
import { ROUTE_ENTITY_MAPPING } from '../utils/constants';

export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const toId = to.params.id as string;
  const fromId = from.params.id as string;
  const toLang = to.params.lang;
  const fromLang = from.params.lang;
  const { deepLoading, silent, source } = to.query as {
    deepLoading?: '0' | '1';
    silent?: '0' | '1';
    source: string;
  };

  if (silent) return next();

  const { hash } = to as { hash: string };

  const knowledgeStore = useKnowledgeStore();

  if (toId && !!to.name && ROUTE_ENTITY_MAPPING[to.name]) {
    if (fromId && toId === fromId && toLang === fromLang) {
      if (hash) knowledgeStore.setContentHash({ hash });
      return next();
    }

    const { modalContent } = storeToRefs(knowledgeStore);

    const actionName =
      deepLoading === '1' || toLang !== fromLang
        ? 'getEntityAncestors'
        : 'getEntity';

    knowledgeStore[actionName]({
      id: toId,
      entityType: ROUTE_ENTITY_MAPPING[to.name],
      isModal: false,
      hash,
      source,
      shouldLog: modalContent.value.id !== toId,
    });
  }

  next();
};
